import axios from 'axios'
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/constants/trans';
import { i18n } from '@/plugins/i18n'
const Trans = {
	get defaultLanguage () {
      return DEFAULT_LANGUAGE
	},

	get supportedLanguagesCode () {
		const supported = SUPPORTED_LANGUAGES.map(s => s.code);
		return supported
	},

	get supportedLanguages () {
		const supported = SUPPORTED_LANGUAGES.map(s => s.language);
		return supported
	},

	get currentLanguage () {
		return i18n.locale
	},

	set currentLanguage (lang) {
		i18n.locale = lang
	},

	getUserSupportedLang () {
		const userPreferredLang = Trans.getUserLang()
		if (Trans.isLangSupported(userPreferredLang.lang)) {
			return userPreferredLang.lang
		}
		if (Trans.isLangSupported(userPreferredLang.langNoISO)) {
			return userPreferredLang.langNoISO
		}
		return Trans.defaultLanguage
	},

	getUserLang () {
    let lang = this.$cookies.get("lang") || window.navigator.language || window.navigator.userLanguage || Trans.defaultLanguage
		lang = lang.replace("-", "_");

		return {
			lang: lang,
			langNoISO: lang.split('-')[0]
		}
	},

	setI18nLanguageInServices (lang) {
		this.$cookies.set("lang",lang, Infinity)
		Trans.currentLanguage = lang
		axios.defaults.headers.common['Accept-Language'] = lang
		document.querySelector('html').setAttribute('lang', lang)
		return lang
	},

	changeLanguage (lang) {
		if (!Trans.isLangSupported(lang)) {
			lang = 'en'
		}
		if (i18n.locale === lang) {
			return Promise.resolve(lang) // has been loaded prior
		}
  
		return Trans.loadLanguageFile(lang).then(msgs => {
			i18n.setLocaleMessage(lang, msgs.default || msgs)
			return Trans.setI18nLanguageInServices(lang)
		})
	},

	loadLanguageFile (lang) {
		return import(`@/lang/${lang}.json`)
	},

	isLangSupported (lang) {
		return Trans.supportedLanguagesCode.includes(lang)
	},

	translate (word) {
		return this.$t(word)
	},

	routeMiddleware (to, from, next) {
		// Load async message files here
		const lang = to.params.lang

		if (!Trans.isLangSupported(lang)) return next(Trans.getUserSupportedLang())
		return Trans.changeLanguage(lang).then(() => next())
	}

}

export { Trans }
